<template>
  <!-- 新增的对话框 修改楼盘佣金 -->
  <el-dialog
    center
    width="750px"
    title="日志详情"
    :visible.sync="dialogFormVisible"
    top="18vh"
    destroy-on-close
    @click="dialogFormVisible = false"
  >
    <el-descriptions :column="1">
      <el-descriptions-item label="请求地址">{{
        form.url
      }}</el-descriptions-item>
      <el-descriptions-item label="用户ID">{{
        form.userId
      }}</el-descriptions-item>
      <el-descriptions-item label="操作状态">{{
        form.statusTxt
      }}</el-descriptions-item>
      <el-descriptions-item label="请求时长（毫秒数）">{{
        form.time
      }}</el-descriptions-item>
      <el-descriptions-item label="用户Ip">{{
        form.userIp
      }}</el-descriptions-item>
      <el-descriptions-item label="用户Mac">{{
        form.macAddress
      }}</el-descriptions-item>
      <el-descriptions-item label="浏览器">{{
        form.browser
      }}</el-descriptions-item>
      <el-descriptions-item label="用户账号">{{
        form.userCode
      }}</el-descriptions-item>
      <el-descriptions-item label="姓名">{{
        handledecrypt(form.userName)
      }}</el-descriptions-item>
      <el-descriptions-item label="操作模块">登录</el-descriptions-item>
      <el-descriptions-item label="操作时间">{{
        form.createTime
      }}</el-descriptions-item>

      <el-descriptions-item label="操作内容">{{
        form.operateContent
      }}</el-descriptions-item>
    </el-descriptions>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        style="margin: 0 10px"
        @click="dialogFormVisible = false"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { decrypt } from '@/utils/encryp';
export default {
  name: 'editHousesRate',
  data() {
    return {
      dialogFormVisible: false,
      form: {},
    };
  },
  inject: ['reload'],
  computed: {},
  mounted() {},
  methods: {
    //下载模板
    handledecrypt(str, isShowAllPhone = true) {
      let showStr = decrypt(str);
      return isShowAllPhone
        ? showStr
        : showStr.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    },
  },
};
</script>

<style></style>
